"use client";

import { Clock, Mail, MessageCircle } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactSupport() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const email = "support@thinklocalpro.com";
  const whatsapp = "1234567890";
  const hours = "MON-FRI: 9AM - 5PM EST";
  const contactMethods = [{
    id: "email",
    title: "SERVICE PROVISION",
    icon: Mail,
    content: <Link to="/PricingPage" className="text-primary hover:text-primary/80 transition-colors text-base font-extrabold uppercase tracking-wider">
          View SaaS & SEO Tiers
        </Link>
  }, {
    id: "whatsapp",
    title: "WHATSAPP USAGE",
    icon: MessageCircle,
    content: <Button asChild variant="default" className="w-full sm:w-auto rounded-[4px] bg-primary hover:bg-primary/90 shadow-[2px_2px_0px_0px_rgba(0,0,0,0.1)]">
          <Link to={whatsapp ? `https://wa.me/${whatsapp}` : "#"} newTab>
            Compliance Guidelines
          </Link>
        </Button>
  }, {
    id: "hours",
    title: "SUPPORT AVAILABILITY",
    icon: Clock,
    content: <span className="text-muted-foreground text-base font-extrabold uppercase tracking-tight">
          {hours || "Hours not specified"}
        </span>
  }];
  return <section data-section-id="184095" id="service-provision-and-whatsapp-usage" className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 max-w-5xl">
        <div ref={ref} className={`flex flex-col items-center text-center space-y-4 mb-12 md:mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-extrabold tracking-tight text-[#262626] uppercase font-sans">
            Service Provision & WhatsApp Usage
          </h2>
          <p className="text-muted-foreground max-w-2xl text-lg font-medium">
            Review our professional service delivery standards and secure communication protocols for automated business engagement.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {contactMethods.map((method, i) => <div key={method.id} data-index={i} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <Card className="h-full flex flex-col items-center text-center p-8 hover:shadow-lg transition-all duration-300 border-secondary bg-card rounded-[4px] shadow-[4px_4px_0px_0px_rgba(0,0,0,0.15)] hover:-translate-y-1">
                <CardHeader className="p-0 mb-6 flex flex-col items-center">
                  <div className="size-14 rounded-[4px] bg-primary/10 flex items-center justify-center mb-5 shadow-sm">
                    <method.icon className="size-7 text-primary" strokeWidth={2} />
                  </div>
                  <CardTitle className="text-xl font-extrabold uppercase tracking-tight text-[#262626] font-sans">
                    {method.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-0 flex-grow flex items-center justify-center w-full">
                  {method.content}
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}